/*
 * (c) 2021 Daniel Kruse <d.kruse@atlantisdx.de>, atlantis dx GmbH
 */
import $ from 'jquery';
import 'slick-carousel';
import 'bootstrap/js/dist/carousel';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { debounce } from 'underscore';

// TODO Two slider implementations used here… Swiper and slick

export default class Application {
	constructor() {
		this.swiper = null;
	}

	/**
	 * Init
	 */
	init(window) {
		this.initSwiperSlider(window);
		this.swiperPagination(window);
	}

	initSwiperSlider(window) {
		if (window.width() < 768) {
			this.swiper = new Swiper('.buhck-tile-view', {
				slidesPerView: 1,
				effect: 'cube',
				grabCursor: true,
				cubeEffect: {
					shadow: false,
					slideShadows: false,
				},
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					clickable: true,
				},
			});
		} else {
			this.swiper = new Swiper('.buhck-tile-view', {
				breakpoints: {
					// when window width is >= 768
					768: {
						slidesPerView: 2,
						slidesPerGroup: 2,
						spaceBetween: 20,
						loop: true,
					},
					// when window width is >= 992
					992: {
						slidesPerView: 3,
						slidesPerGroup: 3,
						spaceBetween: 20,
						loop: true,
					},
				},
				navigation: {
					nextEl: '.news.swiper-button-next',
					prevEl: '.news.swiper-button-prev',
				},
			});
		}
	}

	swiperPagination(window) {
		if (window.width() < 768) {
			const pagination = $(
				'.buhck-tile-view .swiper-pagination.swiper-pagination-bullets.swiper-pagination-horizontal',
			);
			const height = $(pagination).outerHeight();
			const calcHeight = height + 3;
			pagination.css('bottom', -calcHeight);
		}
	}

	/**
	 * On resize Window
	 * @param window
	 */
	responsive(window) {
		this.swiper.destroy();
		this.initSwiperSlider(window);
		this.swiperPagination(window);
	}
}

// todo make container, list images inside container in html
$(document).ready(() => {
	const application = new Application();
	const win = $(window);

	application.init(win);
	win.resize(
		debounce(() => {
			application.responsive(win);
		}, 250),
	);

	$('.detailslider .slider-for').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		asNavFor: '.slider-nav',
	});
	$('.detailslider .slider-nav').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		asNavFor: '.slider-for',
		focusOnSelect: true,
	});

	$('.listslider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					arrows: false,
					dots: true,
				},
			},
		],
	});

	$('.listslider')
		.find('.slick-arrow')
		.on('click', (evt) => {
			evt.preventDefault();
		});
});
